import { inmunetApi } from '../../../api';

export const validar = async({ id, value }) => {

    try {

        const { data } = await inmunetApi.put(`/medicoAdmin/validar/${ id }`, { validar: value });

        if (!data.status) throw (data.msg) ? data.msg : 'Error al actualizar médico';

        return data;

    } catch (error) {

        if (error.response.data.msg) {
            throw new Error(error.response.data.msg);
        } else {
            throw new Error('Error al actualizar médico');
        }

    }

};

export const activar = async({ id, value }) => {

    try {

        const { data } = await inmunetApi.put(`/medicoAdmin/activar/${ id }`, { activo: value });

        if (!data.status) throw (data.msg) ? data.msg : 'Error al actualizar médico';

        return data;

    } catch (error) {

        if (error.response.data.msg) {
            throw new Error(error.response.data.msg);
        } else {
            throw new Error('Error al actualizar médico');
        }

    }

};